import { ALLOWED_TAGS } from '@cigna/resource-content/contracts';

export type TokenMapper = (attributes: { [key: string]: string }) => any[];
export interface MappersConfig {
  [type: string]: TokenMapper;
}

function normalizeNull<T>(value: T | null | undefined): T | null {
  return value ?? null;
}

function unwrapValidationRules() {
  return ALLOWED_TAGS.reduce((mappers: MappersConfig, rule) => {
    const mapper: TokenMapper = (attrs) => [
      ...rule.attributes.map((attr) => normalizeNull(attrs[attr.name])),
      ...Object.keys(attrs)
        .filter((k) => !rule.attributes.some((s) => s.name === k))
        .map((k) => [k, normalizeNull(attrs[k])]),
    ];

    rule.tags.forEach((tag) => {
      mappers[tag] = mapper;
    });

    return mappers;
  }, {});
}

export const TOKEN_MAPPERS: MappersConfig = unwrapValidationRules();

export const GENERIC_TOKEN_MAPPER: TokenMapper = (attrs = {}) =>
  Object.keys(attrs).map((k) => [k, normalizeNull(attrs[k])]);
